import { useApolloClient } from '@apollo/client'
import { getOperationName } from '@apollo/client/utilities'
import {
  ProductBuyBoxPriceAndStockDocument,
  ReferencesProductTableRows_PriceAndStockDocument,
} from '@gql-generated/graphql'
import { useCallback } from 'react'

const ProductBuyBoxPriceAndStockOperationName = getOperationName(ProductBuyBoxPriceAndStockDocument)
const ReferencesProductTableRows_PriceAndStockOperationName = getOperationName(
  ReferencesProductTableRows_PriceAndStockDocument,
)

export function useRefreshProductBuyBoxPriceAndStock() {
  const client = useApolloClient()

  return useCallback(() => {
    if (
      !ProductBuyBoxPriceAndStockOperationName ||
      !ReferencesProductTableRows_PriceAndStockOperationName
    ) {
      console.error('Failed to refetch query ProductBuyBoxPriceAndStock')
    } else {
      client.refetchQueries({
        include: [
          ProductBuyBoxPriceAndStockOperationName,
          ReferencesProductTableRows_PriceAndStockOperationName,
        ],
      })
    }
  }, [client])
}
